export function findAreaElementForPath(widgetPath: string | null | undefined): HTMLElement | null {
  if (!widgetPath) return null
  return document.querySelector<HTMLElement>(`[data-widget-path="${widgetPath}"]`)
}

/** Null when the path is not (or no longer) rendered. */
export function findWidgetIdForPath(widgetPath: string | null | undefined): string | null {
  return findAreaElementForPath(widgetPath)?.dataset.widgetId ?? null
}
